import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import TextTooltipOnHover from '../../Popover/TextTooltipOnHover';
import BiButton from '../../biLogger/Components/BiButton';
import s from './IconButton.scss';
var IconButton = /** @class */ (function (_super) {
    __extends(IconButton, _super);
    function IconButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconButton.prototype.render = function () {
        var _a = this.props, className = _a.className, tooltipText = _a.tooltipText, tooltipOffset = _a.tooltipOffset, disabled = _a.disabled, noHoverEffect = _a.noHoverEffect, _b = _a.noActiveEffect, noActiveEffect = _b === void 0 ? noHoverEffect : _b, onClick = _a.onClick, children = _a.children, biData = _a.biData, restProps = __rest(_a, ["className", "tooltipText", "tooltipOffset", "disabled", "noHoverEffect", "noActiveEffect", "onClick", "children", "biData"]);
        return (React.createElement(BiButton, __assign({ onClick: !disabled ? onClick : undefined, className: classnames(s['root'], disabled && s['disabled'], noHoverEffect && s['no-hover-effect'], noActiveEffect && s['no-active-effect'], className), biData: biData, disabled: disabled }, restProps), tooltipText ? (React.createElement(TextTooltipOnHover, { tooltipText: tooltipText, tooltipOffset: tooltipOffset, oneLine: true }, children)) : (children)));
    };
    return IconButton;
}(React.Component));
export { IconButton };
export default IconButton;
//# sourceMappingURL=IconButton.js.map